export default {
  title: 'Nxcells-h5',
  version: '0.1.0',
  sideBarShow: false,
  locale: 'zh'
}
